import { Trans } from '@lingui/macro'
import LogoChips from 'assets/svg/casino-chips-ico-yellow.svg'
import BigNumber from 'bignumber.js'
import { ButtonPrimary } from 'components/Button'
import Modal from 'components/Modal'
import { useState } from 'react'
import CountUp from 'react-countup'
import { animated, useSpring } from 'react-spring'
import styled from 'styled-components/macro'
import { ThemedText } from 'theme'
import { getFullDisplayBalance } from 'utils/formatBalance'

import { DiceStyledBet, DiceStyledResult } from '../style'

const ResponsiveGrid = styled.div`
  display: grid;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  grid-template-columns: 0.6fr 0.6fr 0.6fr 0.6fr 0.6fr;
  margin-top: 1rem;
`

const TitleWin = () => {
  const [flip, set] = useState(false)
  const props = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    reset: false,
    reverse: flip,
    delay: 50,
    onRest: () => set(!flip),
  })

  return (
    <animated.h1 style={props}>
      <ThemedText.Yellow style={{ textTransform: 'uppercase' }} textAlign="center" fontSize="4rem">
        <Trans>You win</Trans>!
      </ThemedText.Yellow>
    </animated.h1>
  )
}

const TitleLose = () => {
  const [flip, set] = useState(false)
  const props = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    reset: false,
    reverse: flip,
    delay: 50,
    onRest: () => set(!flip),
  })

  return (
    <animated.h1 style={props}>
      <ThemedText.Body style={{ textTransform: 'uppercase' }} textAlign="center" fontSize="4rem" color="#fd3e3e">
        <Trans>You lose</Trans>!
      </ThemedText.Body>
    </animated.h1>
  )
}

export const ResultModal = ({
  isOpen,
  amount,
  arrayWinNumber,
  numbers,
  type,
  onDismiss,
}: {
  isOpen: boolean
  amount: BigNumber | undefined
  arrayWinNumber: any[] | undefined
  numbers: number[]
  type: number | undefined
  onDismiss: () => void
}) => {
  let result = 0
  if (amount) {
    result = parseFloat(getFullDisplayBalance(amount, 18, 2))
  }
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss}>
      <div
        style={{ display: 'flex', flexDirection: 'column', margin: 'auto', justifyContent: 'center', padding: '24px' }}
      >
        <ThemedText.LargeHeader textAlign="center" style={{ textTransform: 'uppercase' }}>
          <Trans>Your bet</Trans>
        </ThemedText.LargeHeader>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
          <DiceStyledBet>{numbers[0]}</DiceStyledBet>
        </div>
        <ThemedText.LargeHeader textAlign="center" style={{ textTransform: 'uppercase' }} marginTop="2rem">
          <Trans>Results</Trans>
        </ThemedText.LargeHeader>
        {arrayWinNumber && arrayWinNumber?.length > 1 ? (
          <ResponsiveGrid>
            {arrayWinNumber?.map((item) => (
              <>
                <DiceStyledResult lose={(type === 0 && item >= numbers[0]) || (type === 1 && item <= numbers[0])}>
                  {item}
                </DiceStyledResult>
              </>
            ))}
          </ResponsiveGrid>
        ) : (
          arrayWinNumber?.map((item) => (
            <>
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                <DiceStyledResult lose={(type === 0 && item >= numbers[0]) || (type === 1 && item <= numbers[0])}>
                  {item}
                </DiceStyledResult>
              </div>
            </>
          ))
        )}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            margin: 'auto',
            justifyContent: 'center',
          }}
        >
          {amount?.gt(0) ? (
            <>
              {TitleWin()}
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <ThemedText.Yellow fontSize="2rem" marginRight="0.5rem">
                  <CountUp start={0} end={result} duration={2} separator=" " decimals={2} decimal="." />
                </ThemedText.Yellow>
                <img src={LogoChips} width="24px" height="100%" alt="" />
              </div>
            </>
          ) : (
            <>{TitleLose()}</>
          )}
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            margin: 'auto',
            justifyContent: 'center',
            width: '80%',
            marginTop: '2rem',
          }}
        >
          <ButtonPrimary onClick={onDismiss}>
            <Trans>Return</Trans>
          </ButtonPrimary>
        </div>
      </div>
    </Modal>
  )
}
